var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C50.1208 64 64 50.1208 64 33C64 15.8792 50.1208 2 33 2C15.8792 2 2 15.8792 2 33C2 50.1208 15.8792 64 33 64Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 20.6L45.4 33L26.8 45.4V20.6Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C50.1208 64 64 50.1208 64 33C64 15.8792 50.1208 2 33 2C15.8792 2 2 15.8792 2 33C2 50.1208 15.8792 64 33 64Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 20.6L45.4 33L26.8 45.4V20.6Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleOutlineIcon);
export default __webpack_public_path__ + "static/media/PlayCircleOutlineIcon.35529a5de1732d639445555037b1adea.svg";
export { ForwardRef as ReactComponent };